<template>
  <v-app
    style="width: 100%"
    class="pa-3 pt-0"
  >
    <v-row
      v-if="$route.name === 'cashPayment'"
      style="margin-top: 50px !important;"
      :style="{'max-height' : (id ? 150 + 'px' : null )}"
      class="my-2 mx-0 px-0"
    >
      <v-col
        cols="12"
        md="1"
        offset-md="3"
        offset-sm="3"
        class="py-1 px-1"
      >
        <v-btn
          v-show="id && payedAmount < totalPrice && items && items.length > 0"
          :loading="loading"
          color="green"
          class="mr-0 mt-9"
          height="69"
          style="font-size: 20px"
          @click="sendPriceToPOS"
        >
          {{ $t('payment') }}
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="4"
        class="py-1 px-1"
      >
        <p align="center">
          {{ $t('forShowInvoiceEnterNumber') }}
        </p>
        <div
          class="main"
        >
          <div class="back ms-1 text-center">
            {{ '8'.repeat((invoiceNumber ? invoiceNumber.length : 0)) }}
          </div>
          <div class="front ms-1 text-center">
            {{ (invoiceNumber ? invoiceNumber : '') }}
          </div>
        </div>
        <div class="mt-5">
          <numpad
            v-show="!id"
            ref="numpadRef"
            @output="setNumber"
            @save="getUidInvoice"
          />
        </div>
      </v-col>
      <v-col
        cols="12"
        md="1"
        class="py-1 px-1"
      >
        <v-btn
          v-show="id"
          :loading="loading"
          color="pink"
          class="mr-0 mt-9"
          height="69"
          @click="clearNumber"
        >
          {{ $t('clear') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      v-show="invoicePayedStatus"
      style="max-height: 110px;"
      class="mx-0"
    >
      <div style="margin: 0px auto">
        <v-alert
          dense
          text
          type="success"
          style="font-size: 20px"
        >
          {{ $t('invoicePayed') }}
        </v-alert>
      </div>
    </v-row>
    <v-row
      v-show="payedAmount && payedAmount >= totalPrice"
      class="mx-0"
      style="max-height: 110px;"
    >
      <div style="margin: 0px auto">
        <v-alert
          dense
          text
          type="success"
          style="font-size: 20px"
        >
          {{ $t('invoicePayedDone') }}
        </v-alert>
      </div>
    </v-row>
    <v-row
      v-show="putCartStatus"
      class="mx-0"
      style="max-height: 110px;"
    >
      <div style="margin: 0px auto">
        <v-alert
          dense
          text
          type="info"
          style="font-size: 20px"
        >
          {{ $t('putCart') }}
        </v-alert>
      </div>
    </v-row>
    <div
      v-show="$route.name === 'cashPayment' && id"
      id="print"
      class="px-3"
    >
      <v-data-table
        v-if="headers && items && items.length > 0"
        ref="table"
        :headers="headers"
        :items="items"
        class="cash-table"
        mobile-breakpoint="0"
        :items-per-page="8000000000000"
        hide-default-footer
      >
<!--        <template v-slot:header="{ props }">-->
<!--          <th-->
<!--            v-for="(head, key) in props.headers"-->
<!--            :key="key"-->
<!--            style="font-size: 10px"-->
<!--          >-->
<!--            {{ head.text.toUpperCase() }}-->
<!--          </th>-->
<!--        </template>-->
        <template v-slot:item.unit="{ item }">
          <div align="center">
            {{ (item.unit ? item.unit.fame : '') }}
          </div>
        </template>
        <template v-slot:item.product="{ item }">
          <div align="center">
            {{ item.product.name }}
          </div>
        </template>
        <template v-slot:item.count="{ item }">
          <div align="center">
            {{ $numberFormat(parseFloat(item.count)) }}
          </div>
        </template>
        <template
          v-slot:item.fee="{ item }"
        >
          <div align="center">
            {{ $numberFormat(parseFloat(item.fee)) }}
          </div>
          <div
            v-if="item.discount && item.discount > 0"
            align="center"
          >
            {{ $numberFormat(parseFloat(item.discount)) }} ( {{ ((parseFloat(item.discount) / parseFloat(item.fee * item.count)) * 100).toFixed(decimal) }} %)
          </div>
          <div
            v-if="item.tax && item.tax > 0"
            align="center"
          >
            {{ $t('tax') }} : {{ $numberFormat(parseFloat(item.tax)) }}
          </div>
        </template>
        <template v-slot:item.row="{ item }">
          <div align="center">
            {{ parseInt(items.indexOf(item))+ parseFloat(1) }}
          </div>
        </template>
        <template v-slot:item.tax="{ item }">
          <div align="center">
            {{ $numberFormat(parseFloat(item.tax)) }}
          </div>
        </template>
        <template v-slot:item.discount="{ item }">
          <div
            v-if="item.discount && item.discount > 0"
            align="center"
          >
            {{ $numberFormat(parseFloat(item.discount)) }} ( {{ ((parseFloat(item.discount) / parseFloat(item.fee * item.count)) * 100).toFixed(decimal) }} %)
          </div>
        </template>
        <template v-slot:item.sum="{ item }">
          <div align="center">
            {{ $numberFormat((parseFloat(item.fee * item.count)).toFixed(decimal)) }}
          </div>
        </template>
        <template v-slot:item.finalAmount="{ item }">
          <div align="center">
            {{ $numberFormat((parseFloat(item.fee * item.count) + parseFloat(item.tax) - parseFloat(item.discount)).toFixed(decimal)) }}
          </div>
        </template>
        <template
          v-slot:body.append="{ item }"
        >
          <tr
            v-show="item && item.discount && item.discount > 0"
            style="background-color: aliceblue;"
            class="hide"
          >
            <td
              :colspan="`${isMobile?4:4}`"
            >
              <strong>{{ $t('sum') }} {{ $t('discount') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?2:2}`"
            >
              <div
                v-if="totalDiscount && totalDiscount > 0"
                align="center"
              >
                {{ $numberFormat(totalDiscount) }} ({{ ((totalDiscount / totals.fee) * 100).toFixed(decimal) }} %)
              </div>
            </td>
          </tr>
          <tr
            v-show="item && item.tax && item.tax > 0"
            style="background-color: aliceblue;"
            class="hide"
          >
            <td
              :colspan="`${isMobile?4:4}`"
            >
              <strong>{{ $t('sum') }} {{ $t('tax') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?2:2}`"
            >
              <div align="center">
                {{ $numberFormat(totals.tax) }}
              </div>
            </td>
          </tr>
          <tr
            style="background-color: aliceblue;"
            class="hide"
          >
            <td
              :colspan="`${isMobile?4:4}`"
            >
              <strong>{{ $t('paymantable') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?2:2}`"
            >
              <div
                align="center"
                style="font-size: 16px"
              >
                {{ $numberFormat(totals.fee - totalDiscount + totals.tax) }}
              </div>
            </td>
          </tr>
          <tr>
            <td
              :colspan="`${isMobile?6:6}`"
            >
              <div
                v-if="content"
                align="center"
                class="my-2"
              >
                {{ content }}
              </div>
              <div
                v-if="self && self.invoiceContent"
                class="mt-2"
                align="center"
                v-html="self.invoiceContent"
              />
            </td>
          </tr>
          <tr>
            <td
              :colspan="`${isMobile?6:6}`"
              class="pt-1"
            >
              <div
                align="right"
              >
                {{ $t('address') }} : {{ (self && self.address ? self.address : '') }}
              </div>
              <div
                align="right"
              >
                {{ $t('phone') }} : {{ (self && self.phone ? self.phone : '') }}
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <div
      v-show="$route.name === 'generalPrint' && id"
      id="print"
      class="px-3"
    >
      <v-data-table
        v-if="headers && items"
        ref="table"
        :headers="headers"
        :items="items"
        :items-per-page="8000000000000"
        hide-default-footer
      >
        <template v-slot:item.unit="{ item }">
          {{ (item.product && item.product.unit ? item.product.unit.fame : '') }}
        </template>
        <template v-slot:item.product="{ item }">
          <div align="center">
            {{ item.product.name }}
          </div>
        </template>
        <template v-slot:item.count="{ item }">
          <div align="center">
            {{ $numberFormat(parseFloat(item.count)) }}
          </div>
        </template>
        <template v-slot:item.fee="{ item }">
          <div align="center">
            {{ $numberFormat(parseFloat(item.fee)) }}
          </div>
        </template>
        <template v-slot:item.row="{ item }">
          <div align="center">
            {{ parseInt(items.indexOf(item))+ parseFloat(1) }}
          </div>
        </template>
        <template v-slot:item.tax="{ item }">
          <div align="center">
            {{ $numberFormat(parseFloat(item.tax)) }}
          </div>
        </template>
        <template v-slot:item.discount="{ item }">
          <div align="center">
            {{ $numberFormat(parseFloat(item.discount)) }}
          </div>
        </template>
        <template v-slot:item.sum="{ item }">
          <div align="center">
            {{ $numberFormat(parseFloat(item.fee * item.count) + parseFloat(item.tax)) }}
          </div>
        </template>
        <template
          v-slot:body.append
        >
          <tr :class="{'v-data-table__mobile-table-row':isMobile}">
            <td
              :colspan="`${isMobile?6:3}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <div align="center">
                {{ (isMobile ? $t('count') + ':' : '') }} {{ $numberFormat(totals.count) }}
              </div>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <div align="center">
                {{ (isMobile ? $t('amount') + ':' : '') }} {{ $numberFormat(totals.fee) }}
              </div>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <div align="center">
                {{ (isMobile ? $t('discount') + ':' : '') }} {{ $numberFormat(totalDiscount) }}
              </div>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <div align="center">
                {{ (isMobile ? $t('tax') +':': '') }}  {{ $numberFormat(totals.tax) }}
              </div>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <div align="center">
                {{ (isMobile ? $t('sum') +':': '') }}  {{ $numberFormat(totals.fee - totalDiscount + totals.tax) }}
              </div>
            </td>
          </tr>
          <tr>
            <td
              :colspan="`${isMobile?6:8}`"
              :class="{'v-data-table__mobile-row':isMobile}"
              class="mt-1"
            >
              {{ $t('content') }} : {{ content }}
            </td>
          </tr>
          <!--          <tr>-->
          <!--            <td-->
          <!--              :colspan="`${isMobile?6:4}`"-->
          <!--              :class="{'v-data-table__mobile-row':isMobile}"-->
          <!--              class="pt-8"-->
          <!--            >-->
          <!--              <div-->
          <!--                align="center"-->
          <!--              >-->
          <!--                {{ $t('buyerSignature') }}-->
          <!--              </div>-->
          <!--            </td>-->
          <!--            <td-->
          <!--              :colspan="`${isMobile?6:4}`"-->
          <!--              :class="{'v-data-table__mobile-row':isMobile}"-->
          <!--              class="pt-8"-->
          <!--            >-->
          <!--              <div align="center">-->
          <!--                {{ $t('sellerSignature') }}-->
          <!--              </div>-->
          <!--            </td>-->
          <!--          </tr>-->
        </template>
      </v-data-table>
    </div>
    <v-row
      v-show="totalPrice && totalPrice > 0 && headers && items && items.length > 0"
      class="mx-0 mt-3"
      style="max-height: 110px;"
    >
      <div style="margin: 0px auto">
        <v-alert
          dense
          text
          type="info"
          style="font-size: 20px"
        >
          {{ $t('amountForPay') }} : {{ $numberFormat(totalPrice) }}
        </v-alert>
      </div>
    </v-row>
    <v-card
      v-show="$route.name === 'generalPrint' && id && self && self.onlineInvoice === 'active'"
      width="100%"
      flat
    >
      <v-card-text
        v-if="type && (type == 'sell' || type === 'presale') && payed && payed.amount < price.price || (type == 'sell' || type === 'presale') && !payed"

        class="mx-auto align-center pb-1"
      >
        <p class="text-center green--text">
          {{ $t('selectGateway') }}
        </p>
      </v-card-text>
      <v-card-text
        v-if="type && (type == 'sell' || type === 'presale') && payed && payed.amount < price.price || (type == 'sell' || type === 'presale') && !payed"
        class="px-4  justify-center xs pb-4 pt-0"
        cols="12"
      >
        <v-chip-group
          v-model="gateway"
          class="justify-center"
          active-class="green--text"
        >
          <v-chip
            v-if="self.zibal"
            value="paymentZibalSystem"
            filter
          >
            <v-img
              max-height="20"
              max-width="70"
              src="@/assets/zibal.svg"
            />
          </v-chip>
          <v-chip
            v-if="self.zarinpal"
            filter
            value="paymentZarinpalSystem"
          >
            <v-img
              max-height="20"
              max-width="70"
              src="@/assets/zarinpal.svg"
            />
          </v-chip>
        </v-chip-group>
      </v-card-text>
      <v-col
        v-if="type && (type == 'sell' || type === 'presale') && payed && payed.amount < price.price || (type == 'sell' || type === 'presale') && !payed"
        class="px-4 mb-4 xs py-0"
        cols="12"
      >
        <v-btn
          v-shortkey="['enter']"
          :disabled="!gateway"
          :loading="loading"
          block
          color="green"
          @shortkey="payment"
          @click="payment"
        >
          {{ $t('payment') }}
          <v-icon
            right
            dark
          >
            mdi-keyboard_return
          </v-icon>
        </v-btn>
      </v-col>
      <v-col
        v-if="payed && payed.amount >= price.price"
        class="px-8 xs py-0 my-4"
        cols="12"
      >
        <v-btn
          block
          color="green"
          outlined
        >
          {{ $t('cleared') }}
        </v-btn>
      </v-col>
    </v-card>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="customSizeDialog"
      width="60%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="customSizeDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print-size') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            sm="6"
            md="6"
          >
            <v-text-field
              v-model="width"
              outlined
              dense
              type="number"
              :label="$t('width') + '(cm)'"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="6"
          >
            <v-text-field
              v-model="height"
              outlined
              dense
              type="number"
              :label="$t('height') + '(cm)'"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                color="primary"
                @click="setCustomeSize"
              >
                {{ $t('submit') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="customSizeDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
  import store from '../../../../store'
  import General from '../../../../Mixins/general'
  import Numpad from '@/views/dashboard/components/general/numpad/index.vue'
  export default {
    components: { Numpad },
    mixins: [General],
    props: ['headerProp', 'itemsProp', 'title', 'idProp'],
    data () {
      return {
        headerPrint: [],
        items: [],
        printType: 'unofficial',
        putCartStatus: false,
        invoicePayedStatus: false,
        decimal: 0,
        payedAmount: 0,
        invoiceNumber: null,
        gateway: null,
        type: null,
        content: null,
        id: null,
        date: null,
        account: null,
        number: null,
        officialNumber: null,
        currency_amount: null,
        dueDate: null,
        currency: null,
        tax: null,
        discount: null,
        entrepot: null,
        totalTax: null,
        totalDiscount: null,
        totalCount: null,
        totalFee: null,
        totalPrice: null,
        sum: null,
        width: null,
        height: null,
        user: null,
        customer: null,
        currencyName: '',
        self: null,
        loading: false,
        headers: null,
        bank: null,
        price: null,
        payed: null,
        customSizeDialog: null,
        printSize: '29.7cm 21cm',
      }
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      totals: function () {
        const totals = this.items.reduce((acc, d) => {
          acc.count += parseFloat(d.count)
          acc.fee += parseFloat(d.fee) * parseFloat(d.count)
          acc.discount += parseFloat(d.discount)
          acc.tax += parseFloat(d.tax)
          return acc
        }, {
          count: 0,
          fee: 0,
          discount: 0,
          tax: 0,
        })
        return totals
      },
    },
    watch: {
      invoicePayedStatus (val) {
        if (val) {
          var app = this
          setTimeout(function () {
            app.invoicePayedStatus = false
          }, 10000)
        }
      },
      invoiceNumber (id) {
        if (!id) {
          this.id = null
          this.items = null
        }
      },
      printType () {
        // if (this.idProp && this.$refs.table) {
        var header = this.$refs.table.$el.querySelector('.v-data-table-header')
        header.deleteRow(0)
        header.deleteRow(0)
        this.setheader()
        //   this.show()
        // }
      },
      headerProp () {
        // this.head = this.itemsProp
      },
      itemsProp () {
        this.items = this.itemsProp
      },
    },
    beforeMount () {
      this.tableHeader()
      if (this.$route.name === 'cashPayment') {
      }
      if (this.$route.name === 'generalPrint' && this.$route.params.id) {
        this.id = this.$route.params.id
        this.show()
      }
      if (this.idProp) {
        this.id = this.idProp
        this.show()
      }
    },
    mounted () {
      if (this.$route.name === 'cashPayment') {
        this.getBank()
      }
    },
    methods: {
      clearNumber () {
        this.payedAmount = null
        this.invoicePayedStatus = false
        this.$refs.numpadRef.cancel()
      },
      sendPriceToPOS () {
        var app = this
        if (!this.bank) {
          app.snakbarColor = 'pink'
          app.snakbarText = app.$t('notFindBankInfo')
          app.snakbar = true
        }
        app.putCartStatus = true
        app.loading = true
        app.isLoading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            pos: 'active',
            posData: app.bank.pos,
            cuid: app.$route.query.cuid,
            amount: +app.totalPrice - +app.payedAmount,
          },
        })
          .then(res => {
            res = res.data
            if (res.IsSuccess) {
              app.snakbarColor = 'green'
              app.snakbarText = app.$t('paymentIsSuccessful')
              app.clearingInvoice()
            } else {
              app.snakbarColor = 'pink'
              app.snakbarText = res.ErrorDescription
              app.showClearing = true
              app.clearingStatus = null
              // app.bank = null
            }
            app.putCartStatus = false
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.isLoading = false
            app.loading = false
          })
      },
      setNumber (value) {
        this.invoiceNumber = value
      },
      edit () {
        this.$router.push({ name: this.type + 'Edit', params: { id: this.idProp } })
      },
      entrepotPrint () {
        this.$router.push({ name: this.entrepot.type + 'Print', params: { id: this.entrepot.id } })
      },
      tableHeader () {
        if (this.$route.name === 'generalPrint') {
          this.headers = [
            {
              text: this.$t('row'),
              align: 'center',
              sortable: false,
              value: 'row',
              width: 20,
            },
            {
              text: this.$t('product') + '/' + this.$t('service'),
              sortable: false,
              value: 'product',
              align: 'center',
            },
            {
              text: this.$t('unit'),
              sortable: false,
              value: 'unit',
              align: 'center',
            },
            {
              text: this.$t('count'),
              sortable: false,
              value: 'count',
              align: 'center',
            },
            {
              text: this.$t('fee') + '(' + this.currencyName + ')',
              sortable: false,
              value: 'fee',
              align: 'center',
            },
            {
              text: this.$t('discount') + '(' + this.currencyName + ')',
              sortable: false,
              value: 'discount',
              align: 'center',
            },
            {
              text: this.$t('tax') + '(' + this.currencyName + ')',
              sortable: false,
              value: 'tax',
              align: 'center',
            },
            {
              text: this.$t('sum') + '(' + this.currencyName + ')',
              sortable: false,
              value: 'sum',
              align: 'center',
            },
          ]
        }
        if (this.$route.name === 'cashPayment') {
          this.headers = [
            {
              text: '#',
              align: 'center',
              sortable: false,
              value: 'row',
            },
            {
              text: this.$t('product') + '/' + this.$t('service'),
              sortable: false,
              value: 'product',
              align: 'center',
            },
            {
              text: this.$t('count'),
              sortable: false,
              value: 'count',
              align: 'center',
            },
            {
              text: this.$t('unit'),
              sortable: false,
              value: 'unit',
              align: 'center',
            },
            {
              text: this.$t('fee') + '(' + this.currencyName + ')',
              sortable: false,
              value: 'fee',
              class: 'hide',
              cellClass: 'hide',
              align: 'center',
            },
            {
              text: this.$t('finalAmount') + '(' + this.currencyName + ')',
              sortable: false,
              value: 'finalAmount',
              class: 'hide',
              cellClass: 'hide',
              align: 'center',
            },
          ]
        }
      },
      setheader () {
        var elm = this.$refs.table.$el.querySelector('.v-data-table-header')
        var tr1 = document.createElement('tr')
        var tr2 = document.createElement('tr')
        tr1.innerHTML = '' +
          '<th colspan="8">' +
          '<div style="display: flex;padding: 10px">' +
          '<div style="width: 33.33%">' +
          '<div align="right"><img class="mx-1" src="' + (this.self.logo ? this.self.logo.link : '') + '" width="50"></div>' +
          '</div>' +
          '<div style="width: 33.33% ">' +
          '<div align="center" style="font-size: 16px">' + this.$t(this.type) + ' </div>' +
          '<div align="center"> ' + this.self.abrName + '</div>' +
          '</div>' +
          '<div style="width: 33.33%">' +
          '<div align="left">' + this.$t('date') + ': ' + this.date + ' </div>' +
          '<div align="left">' + this.$t('number') + ': ' + (this.officialNumber ? this.officialNumber : this.number) + ' </div>' +
          // '<div align="left">' + this.$t('registerar') + ': ' + this.user.name + ' </div>' +
          '</div>' +
          '</div>' +
          '</th>'
        if (this.printType === 'official') {
          tr2.innerHTML = '' +
            '<th colspan="6" style="padding: 6px 6px">' +
            '<div align="right">' + this.$t('seller') + ': ' + this.self.abrName + ' </div>' +
            '<div align="right">' + this.$t('phone') + ': ' + (this.self.phone ? this.self.phone : '') + ' </div>' +
            '<div align="right">' + this.$t('mobile') + ': ' + (this.self.mobile ? this.self.mobile : '') + ' </div>' +
            '<div align="right">' + this.$t('address') + ': ' + (this.self.address ? this.self.address : '') + ' </div>' +
            '</th>' +
            '<th colspan="2" style="padding: 6px 6px">' +
            '<div align="right">' + this.$t('buyer') + ': ' + (this.customer.gender ? this.$t(this.customer.gender) : '') + ' ' + this.customer.name + ' </div>' +
            '<div align="right">' + this.$t('phone') + ': ' + (this.customer.phone ? this.customer.phone : '') + ' </div>' +
            '<div align="right">' + this.$t('mobile') + ': ' + (this.customer.mobile ? this.customer.mobile : '') + ' </div>' +
            '<div align="right">' + this.$t('address') + ': ' + (this.customer.address ? this.customer.address : '') + ' </div>' +
            '</th>'
        } else {
          tr2.innerHTML = '' +
            '<th colspan="8" style="padding: 6px 6px">' +
            '<div align="right">' + this.$t('buyer') + ': ' + (this.customer.gender ? this.$t(this.customer.gender) : '') + ' ' + this.customer.name + ' </div>' +
            '<div align="right">' + this.$t('phone') + ': ' + (this.customer.phone ? this.customer.phone : '') + ' </div>' +
            '<div align="right">' + this.$t('mobile') + ': ' + (this.customer.mobile ? this.customer.mobile : '') + ' </div>' +
            '<div align="right">' + this.$t('address') + ': ' + (this.customer.address ? this.customer.address : '') + ' </div>' +
            '</th>'
        }

        elm.prepend(tr2)
        elm.prepend(tr1)
      },
      getBank () {
        var app = this
        app.loading = true
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            id: app.$route.params.id,
            select: 'getBankCash',
            cuid: app.$route.query.cuid,
          },
        })
          .then(res => {
            res = res.data
            app.bank = res
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.loading = false
            app.isLoading = false
          })
      },
      getUidInvoice () {
        var app = this
        app.loading = true
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            number: app.invoiceNumber,
            select: 'getInvoiceUid',
            cuid: app.$route.query.cuid,
          },
        })
          .then(res => {
            res = res.data
            if (res && res !== '') {
              app.id = res.uid
              app.show()
            } else {
              app.snakbarColor = 'pink'
              app.snakbarText = this.$t('notFindInvoice')
              app.snakbar = true
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.loading = false
            app.isLoading = false
          })
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$apipoint + 'print/invoice/' + this.id, {
          params: {
            id: this.idProp,
            print: 'active',
            cuid: app.$route.query.cuid,
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.id = res.id
              app.currency = res.currency
              app.currency_amount = res.currency_amount
              app.currencyName = res.currency.name
              app.tableHeader()
              app.number = res.number
              app.officialNumber = res.official_number
              app.content = res.content
              app.date = res.date
              app.type = res.type
              app.items = res.article
              app.account = res.customer
              app.entrepot = res.entrepot
              app.dueDate = res.due_date
              app.payed = res.payed
              app.price = res.price
              app.payments = res.payments
              app.checks = res.checks
              app.status = (res.last_status ? res.last_status.status : null)
              app.discount = res.discount
              app.totalDiscount = res.discount
              app.totaltax = res.tax
              app.user = res.user
              app.customer = res.customer
              app.self = res.self
              app.decimal = (res.currency ? res.currency.decimal : 0)
              app.totalPrice = parseInt(res.price.price)
              app.payedAmount = (res.payed ? res.payed.amount : 0)
              store.commit('SET_RTL', app.self.rtl.value)
              store.commit('SET_LANG', app.self.lang.value)
              if (app.$route.name === 'generalPrint') {
                app.setheader()
              }
              setTimeout(function () {
                app.render = true
              }, 1000)
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      clearCustom () {
        this.height = null
        this.width = null
      },
      setCustomeSize () {
        this.printSize = this.width + 'cm ' + this.height + 'cm'
        this.customSizeDialog = false
      },
      print () {
        var direction = 'ltr'
        if (this.$vuetify.rtl) {
          direction = 'rtl'
        }
        var app = this
        var style = '<style>' +
          'table { border: none; border-collapse: collapse; }' +
          'table td { border-left: 1px solid #c3c3c3; }' +
          'table th { border-left: 1px solid #c3c3c3; }' +
          'table td:first-child { border-right: 1px solid #c3c3c3;  }' +
          'table th:first-child { border-right: 1px solid #c3c3c3;  }' +
          'tbody > tr:last-child > td {border: 0px;}' +
          'thead > tr:first-child > th { border-top: 1px solid #c3c3c3; }' +
          '@bottom-left {content: normal;margin: 3px;}' +
          '</style>'
        setTimeout(async function () {
          // Get HTML to print from element
          const prtHtml = document.getElementById('print').innerHTML
          var data = {
            type: 'print',
            body: prtHtml,
          }
          let stylesHtml = ''
          let node = null
          for (node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            stylesHtml += node.outerHTML
          }
          if (app.$route.name === 'cashPayment') {
            const clipText = await navigator.clipboard.writeText(JSON.stringify(data))
            app.copyClip = clipText
            setTimeout(async function () {
              const clipText2 = await navigator.clipboard.writeText(0)
              app.copyClip2 = clipText2
            }, 200)
          } else {
            const WinPrint = window.open('', '', 'left=0,top=0,width=1100,height=900,toolbar=0,scrollbars=0,status=0')
            WinPrint.document.write('<!DOCTYPE html> <html> <head> ' + stylesHtml + ' ' + style + ' </head> <body style="direction: ' + direction + '">' + prtHtml + ' </body> </html>')
            WinPrint.document.close()
            WinPrint.focus()
            setTimeout(function () {
              WinPrint.print()
              WinPrint.close()
            }, 2000)
          }
        }, 50)
      },
      payment () {
        var app = this
        app.loading = true
        app.$axios.get(this.$apipoint + 'print/invoice/' + this.id, {
          params: {
            payment: 'active',
            id: app.id,
            gateway: app.gateway,
            cuid: app.$route.query.cuid,
          },
        })
          .then(res => {
            res = res.data
            window.location.href = res.action
            // window.open(res.action, '_blank')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      clearingInvoice () {
        var app = this
        app.loading = true
        app.$axios.post(this.$endpoint + 'invoice', {
          amount: +app.totalPrice - +app.payedAmount,
          bank: app.bank,
          branch: app.branch,
          currency_amount: app.currency_amount,
          date: app.date,
          customer: app.customer,
          currency: app.currency,
          type: app.type,
          id: app.id,
          cuid: app.$route.query.cuid,
          clearingCashierInvoice: 'active',
        })
          .then(res => {
            res = res.data
            app.invoicePayedStatus = true
            app.print()
            setTimeout(function () {
              app.clearNumber()
            }, 5000)
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>
.main {
  width: 400px;
  background: #fb7c00;
  height: 70px;
  border: 2px solid;
  border-radius: 4px;
  margin: 0px auto
}
.back {
  position: absolute;
  opacity: 0.1;
  font-family: DSEG7 !important;
  font-size: 45px;
  width: 400px;
}
.front {
  z-index: 2;
  position: absolute;
  font-family: DSEG7 !important;
  width: 400px;
  font-size: 45px;
}
</style>
<style  lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'
.theme--light.v-data-table
   .v-data-table__wrapper
      table
        thead
          tr
            th
              font-size: 16px
              color: #595959
   .v-data-table__wrapper
    table
      tbody
        tr
          td
            div
              font-size: 16px
              color: #232323
</style>
